import { Form, Input } from "antd";
import React from "react";

interface EmailProps {
  visible: boolean;
}

const Email: React.FC<EmailProps> = ({ visible }) => {
  return (
    <Form.Item
      name="email"
      label="Email"
      rules={[
        {
          required: true,
          message: "Please enter your email address",
          type: "email",
        },
      ]}
    >
      <Input disabled={!visible} />
    </Form.Item>
  );
};

export default Email;
